import React from 'react';

const PlanWizardStepper = ({ steps, activeStep, t }) => (
  <div className="card card-div plan-wizard-stepper-card">
    <div className="fav-card-content">
      <ul className="list-none p-0 m-0 flex flex-column md:flex-row">
        {steps.map(({ id, label, icon }, i) => (
          <li
            key={id || label}
            className={`relative ${i + 1 !== steps.length ? 'mr-0 md:mr-8' : ''} flex-auto`}
          >
            <div className={`step-box step-box-${activeStep === i ? 'active' : i < activeStep ? 'pre' : 'post'}`}>
              <i
                className={`pi step-box-icon ${
                  activeStep === i
                    ? `step-box-active-icon ${icon}`
                    : i < activeStep
                      ? 'step-box-pre-icon pi-check-circle'
                      : `step-box-post-icon ${icon}`
                }`}
              />
              <div>
                <div
                  className={`step-box-title step-box-${
                    activeStep === i ? 'active' : i < activeStep ? 'pre' : 'post'
                  }-title`}
                >
                  {i + 1 === steps.length
                    ? t('totalTransfers.success')
                    : t('totalTransfers.step', { val: i + 1 })}
                </div>
                <span
                  className={`step-box-des step-box-${
                    activeStep === i ? 'active' : i < activeStep ? 'pre' : 'post'
                  }-des hidden md:block`}
                >
                  {t(label)}
                </span>
              </div>
            </div>
            {i + 1 !== steps.length && <div className="hidden md:block step-box-bar" />}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default PlanWizardStepper;
